export default "__VITE_ASSET__BFX8KEtr__"